module.exports = __webpack_public_path__ + "static/media/afterbanks-avatar.b279dd03.webp";